import React from "react";
import { useSelector, useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { navbarToggler } from "../../redux/actions/utilities";
import YEKGLogo from "../../assets/img/yekg-logo.svg";
import Cookies from "universal-cookie";
import Icon from "../Icon";
const cookies = new Cookies();
export default function SideMenu(props) {
  let { children, ...args } = props;
  const dispatch = useDispatch();
  const sidemenu = useSelector((state) => state.utilities.sidemenu);

  const logout = () => {
    cookies.remove("user");
    window.location.href = "/";
  };
  const navbarToggle = () => {
    dispatch(navbarToggler());
  };

  return (
    <div
      className={`km__c--side-menu ${
        sidemenu ? "km__c--side-menu-is-active" : ""
      }`}
      {...args}
    >
      <span onClick={navbarToggle} className="km__c--side-menu-toggle">
        <Icon
          name={sidemenu ? "collapser" : "expander"}
          size="14"
          color="#6B778C"
        />
      </span>
      <div className="km__c--side-menu-logo">
        <img src={YEKGLogo} alt="" />
      </div>
      <div className="km__c--side-menu-overflow">{children}</div>
      <div className="km__c--side-menu-mobile-sections">
        <div
          className="km__c--side-menu-mobile-item km__c--side-menu-item-group-title"
          onClick={logout}
        >
          <Icon name="x-circle" size="20" color="#6B778C" />
          <span className="text">Çıkış</span>
        </div>
      </div>
      <div className="km__c--side-menu-document">
        <a
          href="https://yekg.epias.com.tr/portal"
          rel="noreferer noopenner noreferrer"
          target="_blank"
        >
          YEK-G Portal
        </a>
        <a
          href="https://yekgnedir.epias.com.tr/"
          rel="noreferer noopenner noreferrer"
          target="_blank"
        >
          YEK-G Nedir?
        </a>
        <a
          href="/YEK-G%20Sistemi%20ve%20Organize%20YEK-G%20Piyasası%20Kullanıcı%20Kılavuzu.pdf"
          rel="noreferer noopenner"
          target="_blank"
        >
          YEK-G Sistemi Kullanıcı Kılavuzu
        </a>
      </div>
      <div className="km__app-version">
        Version: {process.env.REACT_APP_NAME} @{process.env.REACT_APP_VERSION}
      </div>
    </div>
  );
}
SideMenu.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element),
};
